import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function EmbeddedSystems() {
  return <div className="min-h-screen w-full bg-white" data-id="element-479">
      <Hero data-id="element-480" />
      <Capabilities data-id="element-481" />
      <CTA data-id="element-482" />
    </div>;
}